<template src="./PublishedOffers.html">

</template>

<script>
import OfferThumbnail from "@/components/OfferThumbnail/OfferThumbnail";
import ArrobaMedellinArrobitaNoData from "@/components/ArrobaMedellinArrobitaNoData/ArrobaMedellinArrobitaNoData";

export default {
  name: "PublishedOffers",
  props: {
    title: {
      type: String
    },
    offers: {
      type: Array
    }
  },
  components:{
    OfferThumbnail,
    ArrobaMedellinArrobitaNoData
  },
  data (){
    return {
      itemsToShow: Number(2),
    }
  },
  mounted() {
    window.addEventListener('resize', this.reportWindowSize);
    this.reportWindowSize();
  },
  methods:{
    reportWindowSize () {
      if (window.innerWidth < 550){
        this.itemsToShow = Number(1);
      }
      else if (window.innerWidth < 1024){
        this.itemsToShow = Number(2);
      }
      else if (window.innerWidth < 1500){
        this.itemsToShow = Number(3);
      }
      else if (window.innerWidth > 1500){
        this.itemsToShow = Number(4);
      }
    }
  },
}
</script>

<style scoped lang="scss" src="./PublishedOffers.scss">

</style>
